import { normalizeDetail } from "./incidentDetailsValidation"

function parseCoordinates(rawLat, rawLng) {
    if (rawLat == null || rawLng == null || rawLat === '' || rawLng === '') return null
    const lat = Number(rawLat)
    const lng = Number(rawLng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
    // Reject the (0,0) "null island" sentinel — operations leaves placeholder
    // coords on newly-onboarded pickup points until geocoding runs.
    if (lat === 0 && lng === 0) return null
    return { lat, lng }
}

export function buildDirectionsUrl(metadata) {
    if (metadata == null) return null
    const coordinates = parseCoordinates(metadata.latitude, metadata.longitude)
    if (coordinates == null) return null
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(coordinates.lat)},${encodeURIComponent(coordinates.lng)}`
}

// A pin at the given point, e.g. the buyer's current position. Six decimals is ~10cm,
// more than any device reports, and keeps the link short.
export function buildLocationUrl(latitude, longitude) {
    const coordinates = parseCoordinates(latitude, longitude)
    if (coordinates == null) return null
    const lat = Number(coordinates.lat.toFixed(6))
    const lng = Number(coordinates.lng.toFixed(6))
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
}

// RFC 3986 strict encoding: encodeURIComponent leaves !'()* alone, Ruby's ERB::Util.url_encode
// does not, and the two must build the same link.
const encodeQuery = (text) =>
    encodeURIComponent(text).replace(/[!'()*]/g, c => '%' + c.charCodeAt(0).toString(16).toUpperCase())

// A Google Maps search for a typed address. Mirrors platform's
// RecipientDeliveryDetails.address_search_link, which stores this link as the location when the
// buyer gives no Maps link, so the "Ver en Google Maps" preview opens the search ops will open.
export function buildAddressSearchUrl(address, country) {
    const text = normalizeDetail(address)
    if (!text) return null
    const query = [text, country].filter(Boolean).join(', ')
    return `https://www.google.com/maps/search/?api=1&query=${encodeQuery(query)}`
}
